var e=(e,t,a=!1)=>{let o;return(...d)=>{clearTimeout(o),a&&void 0===o&&e.apply(void 0,d),o=setTimeout(()=>{a||e.apply(void 0,d)},t)}};export{e as default};